import { render, staticRenderFns } from "./BaoCaoBangTongHop.vue?vue&type=template&id=69f06dce&scoped=true"
import script from "./BaoCaoBangTongHop.vue?vue&type=script&lang=ts"
export * from "./BaoCaoBangTongHop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f06dce",
  null
  
)

export default component.exports